<template>
    <!-- <a-spin :spinning="spinning" class="spin-box" :tip="$t('spin.text')"> -->
        <v-form
            ref="phoneForm"
            v-model="valid"
            class="form-box formStyle">
                <v-text-field
                    v-if="dataType"
                    v-model="form.password"
                    outlined
                    required
                    :append-icon="isPwdVisible1 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                    dense
                    :error-messages="errorMessage"
                    :type="isPwdVisible1 ? 'text' : 'password'"
                    :label="$t('account.pwd')"
                    :placeholder="$t('account.pwdPlaceholder')"
                    hide-details="auto"
                    :rules="phoneFormRule.password"
                    class="mb-6"
                    @click:append="isPwdVisible1 = !isPwdVisible1"
                ></v-text-field>
                <v-text-field
                    v-model="form.phone"
                    outlined
                    required
                    dense
                    :error-messages="phoneErrMsg"
                    :label="$t('account.pghoess')"
                    :placeholder="$t('account.phonePlaceholder')"
                    hide-details="auto"
                    :rules="phoneFormRule.phone"
                    class="mb-6"
                ></v-text-field>
                <v-row no-gutters>
                    <v-col cols="8" md="8" lg="8" xl="8" sm="12 ">
                        <v-text-field
                            v-model="form.code"
                            outlined
                            required
                            dense
                            :label="$t('account.code')"
                            :placeholder="$t('account.codePlaceholder')"
                            hide-details="auto"
                            :rules="phoneFormRule.code"
                            class="mb-6"
                        >
                        </v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3" md="3" lg="3" xl="3" sm="12" class="code-box  ml-1 d-flex justify-end align-baseline mb-2" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                        <v-btn small outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                        <v-btn small outlined v-else style="width:100%" disabled min-height="40">{{codeText+'s'}}</v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="mb-2">
                        <v-btn color="primary" @click="onSubmit" small>{{$t('btn.submit')}}</v-btn>
                        <v-btn class="close_btn" outlined @click="close" small>{{$t('btn.close')}}</v-btn>
                    </v-col>
                </v-row>
        </v-form>
    <!-- </a-spin> -->
</template>

<script>
import { updatePhone, bindPhone, checkPwd, sendSms } from "@/api/index";
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import store from '@/store'

export default {
    data() {
        return {
            valid: false,
            isPwdVisible1:false,
            form: {},
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline
            },
            errorMessage: undefined,
            phoneErrMsg: undefined,
            phoneFormRule:
                {
                    password: [
                        v => !!v || this.$t('account.pwdPlaceholder'),
                        // v => validatePass(v)
                    ],
                    phone: [
                        v => !!v || this.$t('account.phonePlaceholder'),
                        // v => (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$/.test(v)) || this.$t('account.phoneErr')
                    ],
                    code: [
                        v => !!v || this.$t('account.codePlaceholder'),
                        v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')
                    ],
                },
            codeText: this.$t('account.getCode'),
            spinning: false
        };
    },
    props: {
        dataType: Boolean
    },
    mounted() {
        this.$root.eventHub.$on('handleCancel2', ()=> {
            this.$refs.phoneForm.resetValidation();
            this.$root.eventHub.$off("handleCancel2")
        })
    },
    created() {
        self = this
    },
    watch: {
        'form.password': (val,old) => {
            if(val) {
                self.validatePass(val)
            }
        },
        'form.phone': (val,old) => {
            self.phoneErrFun(val)
        }
    },
    methods: {
        validatePass(v) {
            if(!v){
                this.errorMessage = this.$t('account.pwdPlaceholder')
            }else if(this.$checkPassword(v)){
              //  this.errorMessage = this.$checkPassword(v) == true ? undefined : this.$checkPassword(v)
            }else {
                this.errorMessage = undefined
            }
        },
        phoneErrFun(v) {
            if (!v) {
                this.phoneErrMsg = this.$t('login.retrievePwd.phone')
            } else if(!(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(v))) {
                this.phoneErrMsg = this.$t('login.retrievePwd.phoneErr')
            } else {
                this.phoneErrMsg = undefined
            }
        },
        onSubmit() {
            if(this.$refs.phoneForm.validate()){
                this.$passwordEncryption(this.form.password).then(password=> {
                    let params = {}
                    let apiType = null
                    if (this.dataType) {
                        params = {
                            phonesn: this.form.phone,
                            pwd: password,
                            vCode: this.form.code
                        }
                        apiType = updatePhone
                    } else {
                        params = {
                            phonesn: this.form.phone,
                            vCode: this.form.code
                        }
                        apiType = bindPhone
                    }
                    apiType(params).then(res=> {
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            this.$emit("onSubmit")
                            // this.close()
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    })
                })
            }else{
                return false;
            }
        },
        close() {
            this.$emit("close")
        },
        getCode() {
            if(this.dataType){
                this.phoneErrFun(this.form.phone)
                this.validatePass(this.form.password)
            }else{
                this.phoneErrFun(this.form.phone)
            }
            if(this.phoneErrMsg != undefined && this.errorMessage != undefined){
                return
            }
            if(this.codeText == this.$t('account.getCode') && this.form.phone && !this.dataType || this.codeText == this.$t('account.getCode') && this.form.phone && this.dataType && this.form.password) {
                // 1:注册短信，2:绑定手机短信，4:修改手机号码短信，3:忘记密码短信，5:登录短信，6:重置OTP短信，7:认证短信
                this.$passwordEncryption(this.form.password).then(password=> {
                    let params = {}
                    let apiType = null
                    if (this.dataType) {
                        params = {
                            phonesn: this.form.phone,
                            smsType: this.$getSmsModel('edit'),
                            pwd: password
                        }
                        apiType = checkPwd
                    } else {
                        params = {
                            phonesn: this.form.phone,
                            smsType: this.$getSmsModel('bind'),
                        }
                        apiType = sendSms
                    }
                    apiType(params).then(res=> {
                        // this.spinning = false
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            this.codeText = 60
                            let timer = setInterval(()=>{
                                this.codeText--
                                if(this.codeText <= 0) {
                                    clearInterval(timer)
                                    this.codeText = this.$t('account.getCode')
                                }
                            },1000)
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    }).catch(err=> {
                        // this.spinning = false
                    })
                })
            }
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
.formStyle{
    width: 70%;
    margin-left: 15%;
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
.code-box ::v-deep {
  .v-btn.theme--dark {
    border-color: rgba(231, 227, 252, 0.28) !important;
    .v-btn__content{
      color:rgba(231, 227, 252, 0.67);
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
    ::v-deep {
        .v-text-field.v-text-field--enclosed .v-text-field__details{
            padding: 0;
        }
    }
    .formStyle{
        width: 100%;
        margin-left: 0%;
        margin-top: 10px;
    }
}
</style>
